import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { sleep } from 'src/smoothr-web-app-core/utils/utils';

declare global {
	interface Window {
		NeptingSDK: any;
		NeptingGooglePaySDK: any;
		NeptingApplePaySDK: any;
	}
}

const naptingPaymentUrl = 'https://qualif.nepting.com/epay/payment';

@Injectable({ providedIn: 'root' })
export class NeptingPaymentService {
	private sdkReady = new BehaviorSubject<boolean>(false);
	private sdkGoogleReady = new BehaviorSubject<boolean>(false);
	private sdkAppleReady = new BehaviorSubject<boolean>(false);

	sdkReady$ = this.sdkReady.asObservable();
	sdkGoogleReady$ = this.sdkGoogleReady.asObservable();
	sdkAppleReady$ = this.sdkAppleReady.asObservable();

	private hfields: any;

	constructor() {
		this.waitForSdk('NeptingSDK', this.sdkReady);
		this.waitForSdk('NeptingGooglePaySDK', this.sdkGoogleReady);
		this.waitForSdk('NeptingApplePaySDK', this.sdkAppleReady);
	}

	private waitForSdk(globalKey: keyof Window, subject: BehaviorSubject<boolean>) {
		let attempts = 0;
		const interval = setInterval(() => {
			attempts++;
			if (window[globalKey]) {
				subject.next(true);
				clearInterval(interval);
			}
			if (attempts > 50) clearInterval(interval);
		}, 100);
	}

	configureTransaction(brandId: string, merchantId: string, trx: string) {
		const origin = window.location.hostname;
		window.NeptingSDK?.setTransactionInfo(brandId, merchantId, trx, origin);
		window.NeptingSDK?.setDisplayConecs(true);
	}

	loadHostedFields(fields: any, tokenCb: Function, validCb: Function) {
		this.hfields = window.NeptingSDK?.hostedFields({ fields });
		this.hfields?.load(tokenCb, validCb);
	}

	collectCardData() {
		this.hfields?.collectCardData();
	}

	async redirectToNeptingRaw(payload: Record<string, any>) {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = naptingPaymentUrl;
		form.style.display = 'none';

		Object.entries(payload)
			.filter(([, v]) => v != null)
			.forEach(([key, value]) => {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = String(value);
				form.appendChild(input);
			});

		document.body.appendChild(form);
		form.submit();
	}

	base64Encode(value: string) {
		try {
			return btoa(unescape(encodeURIComponent(value)));
		} catch {
			return '';
		}
	}
}
